import { render } from "./StuffSidebar.vue?vue&type=template&id=b3361ace"
import script from "./StuffSidebar.vue?vue&type=script&lang=js"
export * from "./StuffSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__